import React from 'react';
import SystemArchitecture from './components/SystemArchitecture';

function App() {
  return (
    <div className="container mx-auto py-8 px-4">
      <header className="mb-8 text-center">
        <h1 className="text-3xl font-bold text-blue-800">
          Fusion & X-Ray System Architecture Demo
        </h1>
      </header>
      <main>
        <SystemArchitecture />
      </main>
      <footer className="mt-12 text-center text-gray-500">
        <p>&copy; {new Date().getFullYear()} - System Architecture Demo</p>
      </footer>
    </div>
  );
}

export default App; 